import styled from 'styled-components'
import { navigate } from '@reach/router'
import React, { useEffect, useState } from 'react'
import Card from '@taglivros/oef_componentes/build/components/card'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { useBoletoBancario } from '../../../../contexts/BoletoBancarioContext'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import ModalConfirmacao from '../../../../components/ModalConfirmacao/ModalConfirmacao'
import CartaoCreditoForm from '../../../../components/CartaoCreditoForm/CartaoCreditoForm'
import { MODAL_CONFIRMAR, MODAL_CANCELAR } from '../../PagamentoCartaoCredito/constantsPagamentoCartaoCredito'
import { DESCRICAO_PAGINA_PARAGRAFO_1, DESCRICAO_MODAL_CONFIRMACAO, TITULO_PAGINA, TITULO_MODAL_CONFIRMACAO, descricaoCobrancaMensal } from './constantsTrocarFormaPagamento'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../utils/helpers/helpersAssinatura'
import { formatValor } from '../../../../utils/formatter/formatter'
import { isEmptyObject } from '../../../../utils/helpers/helpers'

const Titulo = styled.h1`
  margin: 5px 0 0 0;

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    margin: 0 0 20px;
  }
`

const Descricao = styled.p`
  ${StyleGuide.tipografia.textoDefault};
  margin: 5px 0 0;
  max-width: 50%;

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    max-width: 100%;
  }

  &:last-of-type {
    margin-bottom: 30px;
  }
`

const Wrapper = styled.div`
  .card {
    position: relative;

    @media( max-width: ${StyleGuide.mediaQuery.tablet} ) {
      margin: 0 0 20px;
      padding: 20px;
    }
  }
`

const TrocarFormaPagamento = () => {
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const { trocarFormaPagamento, getInfosPagamento, infosPagamento } = useBoletoBancario()
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ cartaoCredito, setCartaoCredito ] = useState( {} )
  const [ modalConfirmacao, setModalConfirmacao ] = useState( false )
  const [ valorKit, setValorKit ] = useState( 0 )

  useEffect( () => {
    if ( !isEmptyObject( infosPagamento ) ) {
      setValorKit( formatValor( { 'valor': infosPagamento.valorKit } ) )
    }
  }, [ infosPagamento ] )

  const confirmaMudancaPagamento = cartao => {
    setCartaoCredito( cartao )
    setModalConfirmacao( true )
  }

  const cadastraCartao = () => {
    trocarFormaPagamento( cartaoCredito, idAssinatura )
  }

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setIdAssinatura( assinaturaObtida.id )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( idAssinatura ) {
      getInfosPagamento( idAssinatura )
    }
  }, [ idAssinatura ] )

  return (
    <>
      { modalConfirmacao ?
        <ModalConfirmacao
          acaoPrimariaTitulo={ MODAL_CONFIRMAR }
          acaoSecundariaTitulo={ MODAL_CANCELAR }
          descricao={ DESCRICAO_MODAL_CONFIRMACAO }
          onClickAcaoPrimaria={ () => cadastraCartao() }
          onClickAcaoSecundaria={ () => setModalConfirmacao( false ) }
          titulo={ TITULO_MODAL_CONFIRMACAO }
        /> : null}

      <BreadcrumbGlobal
        exactPath="trocar-forma-pagamento"
        nomeAlternativo="Trocar forma de pagamento"
        padding="20px 0"
      />

      <Titulo>
        { TITULO_PAGINA }
      </Titulo>

      <Descricao>
        { DESCRICAO_PAGINA_PARAGRAFO_1 }
      </Descricao>

      { valorKit ?
        <Descricao>
          { descricaoCobrancaMensal( valorKit ) }
        </Descricao> : null}

      <Wrapper>
        <Card
          className="card"
          largura="calc(61% - 20px)"
          margin="0 0 30px 0"
        >
          <CartaoCreditoForm
            onCancelar={ () => navigate( `${modalidadeURL}/pagamento` ) }
            onConfirmar={ ( cartaoRetornado ) => confirmaMudancaPagamento( cartaoRetornado ) }
          />
        </Card>
      </Wrapper>
    </>
  )
}

export default TrocarFormaPagamento

